import React, { useMemo } from 'react';

import { MAP_HEIGHT, MAP_PADDING, MAP_WIDTH } from './constants';
import { geometryToPath, getBounds, projectPoint, unprojectPoint } from './geometry';
import { CzechiaSvg } from './styled';

export const SvgMap = ({
    answerState,
    correctRegionCode,
    features,
    guessPoint,
    onMapClick,
    onRegionClick,
    selectedRegionCode,
    targetPoint,
}) => {
    const bounds = useMemo(() => getBounds(features), [features]);

    const handleClick = event => {
        if (!onMapClick) {
            return;
        }

        const rect = event.currentTarget.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * MAP_WIDTH;
        const y = ((event.clientY - rect.top) / rect.height) * MAP_HEIGHT;
        onMapClick(unprojectPoint({ x, y }, bounds, MAP_WIDTH, MAP_HEIGHT, MAP_PADDING));
    };

    const renderMarker = (point, color, stroke) => {
        if (!point) {
            return null;
        }
        const { x, y } = projectPoint(point, bounds, MAP_WIDTH, MAP_HEIGHT, MAP_PADDING);
        return <circle cx={x} cy={y} r="7" fill={color} stroke={stroke} strokeWidth="3" />;
    };

    const renderLine = () => {
        if (!guessPoint || !targetPoint) {
            return null;
        }
        const start = projectPoint(guessPoint, bounds, MAP_WIDTH, MAP_HEIGHT, MAP_PADDING);
        const end = projectPoint(targetPoint, bounds, MAP_WIDTH, MAP_HEIGHT, MAP_PADDING);
        return (
            <line
                x1={start.x}
                y1={start.y}
                x2={end.x}
                y2={end.y}
                stroke="#c80707"
                strokeWidth="2.5"
                strokeDasharray="6 6"
            />
        );
    };

    return (
        <CzechiaSvg viewBox={`0 0 ${MAP_WIDTH} ${MAP_HEIGHT}`} onClick={handleClick}>
            <rect width={MAP_WIDTH} height={MAP_HEIGHT} fill="#f7fafc" />
            {features.map(feature => {
                const isCorrect = correctRegionCode && feature.id === correctRegionCode;
                const isSelected = selectedRegionCode && feature.id === selectedRegionCode;
                const isWrongSelection = answerState === 'wrong' && isSelected && !isCorrect;
                const fill = isCorrect
                    ? '#d9f7be'
                    : isWrongSelection
                    ? '#ffd6d6'
                    : isSelected
                    ? '#fff1b8'
                    : '#ffffff';

                return (
                    <path
                        key={feature.id}
                        d={geometryToPath(feature.geometry, bounds, MAP_WIDTH, MAP_HEIGHT, MAP_PADDING)}
                        fill={fill}
                        fillRule="evenodd"
                        stroke={isCorrect || isSelected ? '#c80707' : '#7b8794'}
                        strokeWidth={isCorrect || isSelected ? 2.2 : 1}
                        style={{ cursor: onRegionClick ? 'pointer' : onMapClick ? 'crosshair' : 'default' }}
                        onClick={event => {
                            if (onRegionClick) {
                                event.stopPropagation();
                                onRegionClick(feature.id);
                            }
                        }}
                    />
                );
            })}
            {renderLine()}
            {renderMarker(targetPoint, '#52c41a', '#237804')}
            {renderMarker(guessPoint, '#c80707', '#ffffff')}
        </CzechiaSvg>
    );
};
